import { BaseComponent } from '../../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../../components/Box';
import { VehicleCreditorField } from './Fields';
import { fetchCompany, setCompanyProperty, toggleNotification } from '../../../../../Companies/actions';
import { selectNewVehicle } from '../../../../selectors';
import { getPropByName } from '../../../../../../utils/props';
import { setNewVehicleValue } from '../../../../actions';
import { selectConfig, selectWork, selectWorks } from '../../../../../Api/selectors';
import { CompanyQuickCreator } from '../../../../../Companies/pages/QuickCreate/QuickCreate';
import {
  COMPANY_VINDAT_TRANSPORT_PURPOSE_OPTION,
  REQUEST_COMPANY_ADD_USER,
  REQUEST_COMPANY_PROPERTY_UPDATE,
} from '../../../../../Companies/constants';
import { REQUEST_USER } from '../../../../../Users/constants';
import { selectHomeCompany, selectNotification } from '../../../../../Companies/selectors';
import { Notification } from '../../../../../../components/Notification';
import { selectNewInvoice } from '../../../../../Invoices/selectors';
import { setNewInvoiceValue } from '../../../../../Invoices/actions';
import cn from 'classnames';
import ModalComponent from '../../../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../../../containers/App/Components/Checkbox/Checkbox';
import env from '../../../../../../env';
import styles from './SelectVehicleCreditorCompany.module.css';
import { AppClientId } from '../../../../../Shared/constants';
import LoadingField from '../../../../../../containers/App/Components/LoadingField/LoadingField';

const Container = styled.div`
  visibility: ${props => (props.customerModal ? 'hidden' : '')};
`;

const User = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(50% - 10px);
  min-height: 140px;
  margin: 8px 0;
  font-size: 14px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 14px;
  }
  .user {
    margin-top: 12px;
  }

  .req-field-message {
    color: red;
  }
`;

const STATE = {
  creditorCompany: null,
  user: null,
  showCustomerModal: false,
  no_release_before_incoming_transport: '0',
  no_incoming_payment_before_transport: '0',
  wait_for_pickup: '0',
  showPopup: true,
};

/* eslint-disable react/prefer-stateless-function */
class SelectCreditorModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (env.clientId === AppClientId.HILTERMANN) {
      this.props.setValue(this.props.homeCompany, 'creditor_company');
    }
    if (this.props.tradeInVehicle) {
      this.props.setValue(this.props.defaultCreditor, 'creditor_company');
    }
    if (this.props.values.creditor_company) {
      this.props.fetchCompany(this.props.values?.creditor_company, result => {
        if (result.id) {
          this.setState({ creditorCompany: result });
          if (env.clientId === AppClientId.HILTERMANN) {
            this.props.handleNext();
          }
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchCompany, values } = this.props;
    if (prevProps.values?.creditor_company !== values.creditor_company) {
      fetchCompany(values?.creditor_company, result => {
        if (result.id) {
          this.setState({ creditorCompany: result });
          if (env.clientId === AppClientId.HILTERMANN) {
            this.props.handleNext();
          }
        }
      });
    }
    if (!this.state.creditorCompany && values.creditor_company) {
      fetchCompany(values?.creditor_company, result => {
        if (result.id) {
          this.setState({ creditorCompany: result });
          if (env.clientId === AppClientId.HILTERMANN) {
            this.props.handleNext();
          }

          if (this.props.tradeInVehicle) {
            const user = result?.users?.find(u => u.id == this.props.defaultCreditorUser);
            this.handleSetUser(user);
          }
        }
      });
    }

    if (this.props.notification?.isShow) {
      this._t = this.timeout(
        () => {
          this.props.toggleNotification();
        },
        5000,
        this._t,
      );
    }
  }

  get isShowCreditorPopup() {
    const isShow =
      this.state.showPopup &&
      (!getPropByName(this.state.creditorCompany, 'no_release_before_incoming_transport') ||
        !getPropByName(this.state.creditorCompany, 'no_incoming_payment_before_transport') ||
        !getPropByName(this.state.creditorCompany, 'wait_for_pickup'));
    return isShow;
  }

  handleSetUser = u => {
    if (u?.id) {
      this.setState({ user: u });
      return this.props.setValue(u.id, 'creditor');
    }
    return;
  };

  openCustomerModal() {
    this.setState({ showCustomerModal: true });
  }

  applyDisabled() {
    // TODO-3500
    return false;
    if (!this.props.values?.creditor_company) return true;
    if (!this.props.values?.creditor && !this.props?.serverConfig?.incomingContactOptional) return true;

    return getPropByName(this.state.creditorCompany, 'incoming_block') === '1';
  }

  onPropertySelect(propertyName) {
    if (this.state[propertyName] === '0') {
      return this.setState({ [propertyName]: '1' });
    }
    return this.setState({ [propertyName]: '0' });
  }

  editCompany() {
    let props = COMPANY_VINDAT_TRANSPORT_PURPOSE_OPTION.map(prop => [prop, this.state[prop]]);

    this.props.onUpdateCompanyProps(this.state.creditorCompany?.id, props, result => {
      this.setState({ showPopup: false });
    });
  }

  handleNextClick = () => {
    const { handleNext, onConfirm } = this.props;

    if (handleNext) {
      handleNext();
    }

    if (onConfirm) {
      onConfirm({
        creditorCompany: this.state.creditorCompany,
        creditor: this.state.creditor,
      });
    }
  };

  render() {
    if (env.clientId === AppClientId.HILTERMANN) {
      return (
        <ModalComponent size="xl">
          <HBox gap={'8px'}>
            <VBox>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
            </VBox>
            <VBox>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
            </VBox>
            <VBox>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
              <LoadingField></LoadingField>
            </VBox>
          </HBox>
        </ModalComponent>
      );
    }
    return (
      <>
        {this.state.showCustomerModal && (
          <CompanyQuickCreator incomingModal={true} resetQuickModal={() => this.setState({ showCustomerModal: false })} />
        )}
        {this.props.notification?.isShow == '1' && (
          <Notification>{this.lbl(`company.create.${this.props.notification?.message}`)}</Notification>
        )}
        <Container customerModal={this.state.showCustomerModal}>
          <ModalComponent
            size="xl"
            className={styles.modal}
            onClose={this.props.reset}
            title={this.lblStr('vehicle.create.select_creditor')}
          >
            {this.state.creditorCompany?.id && this.isShowCreditorPopup}
            {!this.props.work && (
              <VBox left>
                {!this.props.tradeInVehicle
                  ? (() => {
                      return (
                        <VehicleCreditorField
                          key={'creditor_company'}
                          type={'creditor_company'}
                          invoicePage={this.props.invoicePage}
                          showNewCompanyModal={this.openCustomerModal.bind(this)}
                        />
                      );
                    })()
                  : (() => {
                      return (
                        <VehicleCreditorField
                          tradeInVehicle
                          key={'creditor_company'}
                          type={'creditor_company'}
                          invoicePage={this.props.invoicePage}
                          showNewCompanyModal={this.openCustomerModal.bind(this)}
                        />
                      );
                    })()}

                {env.clientId !== AppClientId.INDEWAL ||
                  (env.clientId !== AppClientId.HARRY_NIJBOER && (
                    <HBox left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }} className={'address-block'}>
                      {this.state.creditorCompany?.users.map(user => (
                        <User
                          key={`${user?.id}`}
                          onClick={() => this.handleSetUser(user)}
                          isActive={this.state.user?.id === user?.id}
                        >
                          <VBox spaceAround className="user-box">
                            <HBox vCenter>
                              <h6 className="name">
                                {getPropByName(user, 'name')}&nbsp;{getPropByName(user, 'surname')}
                              </h6>
                              <CheckboxComponent checked={this.state.user?.id === user?.id} />
                            </HBox>
                            <VBox className="user">
                              <div className={styles.email}>{user['email_address']}</div>
                            </VBox>
                          </VBox>
                        </User>
                      ))}
                    </HBox>
                  ))}
              </VBox>
            )}
            {getPropByName(this.state.creditorCompany, 'incoming_block') === '1' && (
              <HBox>
                <strong>{this.lbl('company.block_invoice_sorry')}</strong>
              </HBox>
            )}
            <HBox right>
              <div className="d-flex gap-2">
                <ButtonComponent
                  onClick={() => {
                    ['creditor_company', 'creditor'].map(type => this.props.setValue(null, type));
                    return this.props.reset();
                  }}
                  style={'ButtonSoftLight'}
                >
                  {this.lbl(`cancel`)}
                </ButtonComponent>

                <ButtonComponent style="ButtonSoftPrimary" disabled={this.applyDisabled()} onClick={this.handleNextClick}>
                  Next
                </ButtonComponent>
              </div>
            </HBox>
          </ModalComponent>
        </Container>
      </>
    );
  }
}

SelectCreditorModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  reset: PropTypes.func,
  onNextModal: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: ownProps.invoicePage ? selectNewInvoice() : selectNewVehicle(),
    work: selectWorks([REQUEST_COMPANY_ADD_USER, REQUEST_USER]),
    workCompanyEdit: selectWork(REQUEST_COMPANY_PROPERTY_UPDATE),
    notification: selectNotification(),
    homeCompany: selectHomeCompany(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      ownProps.invoicePage ? dispatch(setNewInvoiceValue(name, value)) : dispatch(setNewVehicleValue(name, value));
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    onUpdateCompanyProps(companyId, props, callback) {
      props.map((prop, index) =>
        dispatch(setCompanyProperty(companyId, prop[0], prop[1], index == props.length - 1 && callback)),
      );
      // dispatch(setCompanyProperty(companyId, name, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SelectCreditorModal = compose(withConnect, withRouter, injectIntl)(SelectCreditorModalComp);
